/* =========================================================
	SITE-WIDE SCRIPTS

	1.0 Imports & Alpine
	2.0 Announcement bar
	3.0 Mobile nav show/hide header
	4.0 Events calendar enhancements
========================================================= */

/* 1.0 Imports & Alpine ---------------- */
// Alpine is required for desktop nav
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
window.Alpine = Alpine
Alpine.plugin(collapse)
Alpine.start()

import UIkit from 'uikit';
import "./includes/slideToggle";

/* 2.0 Announcement bar ---------------- */
// Requires includes/slideToggle.js
let announcementBar = document.querySelector(".announcement-bar");

if(typeof(announcementBar) != 'undefined' && announcementBar != null){
	let announcementBtn = document.querySelector('.announcement-button');

	// when you click the button, open and close the div:
	announcementBtn.addEventListener('click', () => {
		document.querySelector('.announcement-text').slideToggle();
		announcementBtn.classList.toggle('expanded')
	});
}

/* 3.0 Mobile nav show/hide header ---------------- */
// Show/hide nav based on scroll direction
// Reference: https://daily-dev-tips.com/posts/show-and-hide-a-header-based-on-scroll-direction/

// Get the mobile header
const header = document.querySelector("header.sitenav.mobile");

if(typeof(header) != 'undefined' && header != null){
	let lastScroll = 0;

	const throttle = (func, time = 100) => {
		let lastTime = 0;
		return () => {
		  const now = new Date();
		  if (now - lastTime >= time) {
			 func();
			 time = now;
		  }
		};
	};

	const validateHeader = () => {
		const windowY = window.scrollY;
		const windowH = window.innerHeight * .85;
		// const scrollPointH = 300;

		if (windowY > windowH) {
			// We passed the first section, set a toggable class
			header.classList.add("is-fixed");

			// Determine if we ready to animate
			if (windowY > windowH) {
				header.classList.add("can-animate");

				if (windowY < lastScroll) {
					// Determine if we are scrolling up
					header.classList.add("scroll-up");
				} else {
					header.classList.remove("scroll-up");
				}
			} else {
				header.classList.remove("scroll-up");
			}
		} else {
			header.classList.remove("is-fixed", "can-animate");
		}

		lastScroll = windowY;
	};

	window.addEventListener("scroll", throttle(validateHeader, 100));
}


/* 4.0 Events calendar enhancements ---------------- */
// Get the calendar
let calendar = document.querySelector('.inline-calendar');
let calendarDates = document.querySelectorAll('.calendar-date');

// Ensure calendar exists before doing anything else
if (typeof(calendar) != 'undefined' && calendar != null) {
	calendarDates.forEach(function(item){
		let calDate = item.getAttribute('data-date');
		let pageDate = item.getAttribute('data-date-page');
		let calIndex = item.getAttribute('data-index');

		if (calDate == pageDate) {
			item.classList.add('current-date');
			UIkit.slider(calendar).show(calIndex);
		}
	});
}
